// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__ZuGsc","globalLoader":"loader_globalLoader__uakbP","loaderLine":"loader_loaderLine__zVJ0o"};